import React, { useState, useEffect, useRef, useCallback, } from "react";
import { keyPress } from "../../utils/keyPress";
import { FilterWrapper } from "./FilterWrapper";
import { Button } from "../../Button";
import { FormConsumer } from "../../Form";
import { useTranslation } from "../../hooks/useTranslation";
export const FutureInputFilter = ({ label, extraClass, direction = "right", children, selected, onSubmit, onClear, id, }) => {
    const [isMenuVisible, setIsMenuVisible] = useState(false);
    const t = useTranslation();
    const elementRef = useRef(null);
    const mouseDownHandler = useCallback((ev) => {
        if (elementRef.current) {
            if (!elementRef.current.contains(ev.target) &&
                document.body.contains(ev.target)) {
                setIsMenuVisible(false);
            }
        }
    }, []);
    const keyFunctions = useCallback((event) => {
        if (event.keyCode === keyPress.ESCAPE) {
            setIsMenuVisible(false);
        }
    }, []);
    useEffect(() => {
        /* TODO Make into a Hook */
        if (isMenuVisible) {
            document.addEventListener("keydown", keyFunctions, false);
        }
        document.addEventListener("mousedown", mouseDownHandler);
        return () => {
            if (isMenuVisible) {
                document.removeEventListener("keydown", keyFunctions, false);
            }
            document.removeEventListener("mousedown", mouseDownHandler);
        };
    }, [keyFunctions, mouseDownHandler, isMenuVisible]);
    return (React.createElement("div", { ref: elementRef, id: id },
        React.createElement(FilterWrapper, { visible: isMenuVisible, onChange: () => {
                setIsMenuVisible(!isMenuVisible);
            }, label: label, value: selected },
            React.createElement("div", { className: `affectBar--filter-box affectBar--filter-box-form affectBar--filter-box--${direction} ${extraClass ? extraClass : ""}` },
                children,
                React.createElement(FormConsumer, null, ({ values }) => (React.createElement("div", { className: "filter-box--buttons" },
                    React.createElement(Button, { onClick: () => {
                            onSubmit();
                            setIsMenuVisible(false);
                        }, label: t("Submit"), type: "primary", id: id && `${id}__submit` }),
                    React.createElement(Button, { onClick: () => {
                            onClear(values);
                            setIsMenuVisible(false);
                        }, label: t("Clear"), id: id && `${id}__clear` }))))))));
};
